// @flow
import { type Surface } from 'app/common/react/components/PinRep/core/PinRepConfiguration';

/**
 * Creates a root margin to pass to an IntersectionObserver based on what components
 * we have in the header area of the page. These components determine the visibility
 * of videos when at the top of the page. Each surface has different components in the
 * header.
 * @param {string} surface surface name.
 * @returns {string} root margin with the sum of how much to offset the top.
 */
export const getIntersectionObserverRootMargin = (surface: ?Surface) => {
  if (typeof window === 'undefined') {
    return '';
  }

  let totalTopOffset = 0;
  // This is the main header. It exists for all surfaces.
  const mainHeader = document.querySelector('[data-test-id="header"]');
  if (mainHeader !== null) {
    const { height } = mainHeader.getBoundingClientRect();
    totalTopOffset += height;
  }

  switch (surface) {
    case 'AuthHomefeed':
      const moreIdeasTabs = document.querySelector('[data-root-margin="more-ideas-tabs"]');
      if (moreIdeasTabs !== null) {
        const { height: moreIdeasTabsHeight } = moreIdeasTabs.getBoundingClientRect();
        totalTopOffset += moreIdeasTabsHeight;
      }
      break;
    case 'SearchItem':
      const searchImprovementBar = document.querySelector(
        '[data-root-margin="search-improvements-bar"]',
      );
      if (searchImprovementBar !== null) {
        const {
          height: searchBarImprovementsBarHeight,
        } = searchImprovementBar.getBoundingClientRect();
        totalTopOffset += searchBarImprovementsBarHeight;
      }
      break;
    default:
      break;
  }

  // Need to multiply by -1 since we're offsetting from the top.
  return `${totalTopOffset * -1}px 0px 0px 0px`;
};

export default {};
